/** @format */

import styled from 'styled-components';

export const FormContainer = styled.form`
  width: min(25rem, 95%);
  background-color: white;
  padding: 1rem;
  border-radius: 1rem;
  h3 {
    text-align: center;
  }
  .Input {
    display: block;
    width: 100%;
    padding: 0.3rem 0.8rem;
    margin-bottom: 1rem;
    border-radius: 0.25rem;
    border: 1px solid black;
    resize: none;
  }
  .TextArea {
    height: 9rem;
  }
  .CheckBox {
    display: flex;
    align-items: baseline;
    gap: 0.8rem;
    margin-bottom: .8rem;
    p{
      color: ${props => props.theme?.colors?.primary ? props.theme?.colors?.primary : 'var(--primary)'};
    }
  }
  button {
    border: none;
    width: 100%;
     background-color: ${props => props.theme?.colors?.primary ? props.theme?.colors?.primary : 'var(--primary)'};
    color: white;
    border-radius: 0.4rem;
    padding: 0.45rem;
  }
`;
